import Vue from 'vue'

const numberFormat = new Intl.NumberFormat('en-US')

Vue.prototype.numberFormat = (value) => {
	return numberFormat.format(value)
}